import React, { useEffect, useMemo, useState } from 'react';
import {
  IonContent,
  IonPage,
  IonImg,
  IonBackButton,
  IonButton,
  IonButtons,
  IonIcon,
} from '@ionic/react';
import { useHistory } from 'react-router';
import { chevronBack } from 'ionicons/icons';

import Card from '../Card';
import CommonHeader from '../CommonHeader';
import ExploreContainer from '../ExploreContainer';

import { useURLStore } from '../stateManagement/URLZustand';
import { useTreeStore } from '../stateManagement/treeZustand';
import { isLabelEmpty } from '../../foo/grid';
import { _rootName } from '../constants';

import './TemplateQ1.css';

const TemplateQ1: React.FC = () => {
  const history = useHistory();
  const { URLVars, getNextNodePath, getURLTo } = useURLStore();
  const { nodes, getImage } = useTreeStore();

const cards = useMemo(() => {
    if (!URLVars.nodePath) return [];

    const newCards = nodes[URLVars.nodePath]
        .filter(label => !isLabelEmpty(label))
        .sort(() => 0.5 - Math.random());

    return newCards;
}, [nodes, URLVars.nodePath]);

  const handleClick = (label: string) => {
    const nextPath = getNextNodePath(label);
    if (nodes[nextPath] && nodes[nextPath].length > 0 && URLVars.mainImageLabel) {
      history.push(getURLTo().task(1, URLVars.mainImageLabel, nextPath));
    }
  };

  const showBackButton = useMemo(() => {
    return getURLTo().talkFromCustomNodePath(URLVars.parentNodePath || _rootName).endsWith(URLVars.mainImageLabel!)
  }, [URLVars.parentNodePath, URLVars.nodePath]);

  const handleGoBack = () => {
    
    
    history.push(getURLTo().task(1, URLVars.mainImageLabel!, URLVars.parentNodePath || _rootName));
  }
  if(!URLVars.nodePath || cards.length === 0) return (<></>);
  return (
    <IonPage>
      <CommonHeader />
      <IonContent fullscreen>
        <ExploreContainer key={URLVars.nodePath+"-"+cards.length} mainContent={
          <div >
            {URLVars.mainImageLabel && (
              <IonImg src={getImage(URLVars.mainImageLabel)} className="big-image" />
            )}
            <div style={{ display: 'flex', flexWrap: 'wrap' }} id="mainContentNoGrid">
              {showBackButton && (
                <IonButton onClick={handleGoBack} color="light">
                  <IonIcon icon={chevronBack} slot="start" />
                </IonButton>
              )}
              {cards.map((child, index) => (
                <Card
                  key={`${URLVars.nodePath}-${index}`}
                  index={index}
                  label={child}
                  disableGoToNextNode={true}
                  executeOnClick={() => handleClick(child)}
                />
              ))}
            </div>
          </div>
        } />
      </IonContent>
    </IonPage>
  );
};

export default TemplateQ1;
